/**
 * Base manager: in-memory data store for a module's entities, plus the schema
 * that drives forms/display. Modules extend and add entity-specific helpers.
 */
export default class BaseManager {
  constructor(idField = "id") {
    this.idField = idField;
    this.items = [];
  }

  set(items) {
    this.items = Array.isArray(items) ? items : [];
    return this.items;
  }

  all() {
    return this.items;
  }

  get(id) {
    return this.items.find((it) => it[this.idField] === id);
  }

  upsert(item) {
    const i = this.items.findIndex((it) => it[this.idField] === item[this.idField]);
    if (i >= 0) this.items[i] = item;
    else this.items.push(item);
    return item;
  }

  remove(id) {
    this.items = this.items.filter((it) => it[this.idField] !== id);
  }

  /** Field schema for forms/display — override in subclasses. */
  getFieldSchema() {
    return [];
  }
}
